import { connect } from "react-redux";
import { RootState } from "store/store";
import BillingIntervalDisplay from "./BillingIntervalDisplay";
import { BillingInterval } from "shared/enums/BillingIntervalEnum";
import NextPaymentDetails from "interfaces/response/NextPaymentDetails";
import { NextPaymentDetailsType } from "shared/enums/NextPaymentDetailsTypeEnum";
import { getFormattedNumber } from "shared/utility/NumberUtility";
import {
  getDateMonthNameYearFromString,
  getFullDateFromString,
} from "shared/utility/DateTimeUtility";

export interface Props {
  numberOfAction?: number;
  actionTag?: string;
  price?: string;
  billingInterval: BillingInterval;
  nextPaymentDetails: NextPaymentDetails;
}

export function CurrentPlanCard(props: Props) {
  const {
    numberOfAction,
    actionTag,
    price,
    billingInterval,
    nextPaymentDetails,
  } = props;
  let className = "text-sm font-bold mt-2";

  const GetNextPaymentTextForCurrentPlan = () => {
    let nextPaymentText: string = "";
    const nextPaymentdate = getDateMonthNameYearFromString(
      nextPaymentDetails.date
    );

    if (nextPaymentDetails.type === NextPaymentDetailsType.Free) {
      nextPaymentText = "Free license";
    } else if (nextPaymentDetails.type === NextPaymentDetailsType.Active) {
      nextPaymentText = nextPaymentdate;
    } else if (nextPaymentDetails.type === NextPaymentDetailsType.Downgrade) {
      nextPaymentText = `${getFullDateFromString(
        nextPaymentDetails.date
      )} - downgraded plan`;
    } else if (nextPaymentDetails.type === NextPaymentDetailsType.GracePeriod) {
      nextPaymentText = `${nextPaymentdate}`;
      className = `${className}`;
    } else if (nextPaymentDetails.type === NextPaymentDetailsType.PaymentDue) {
      nextPaymentText = "Payment failed";
      className = `${className} text-promRed1`;
    }

    return <div className={className}>{nextPaymentText}</div>;
  };

  return (
    <div>
      <div className="text-sm font-medium text-promGray2">{actionTag}</div>
      <div className="text-4xl text-primaryRed font-semibold mb-3">
        {getFormattedNumber(numberOfAction ?? 0)}
      </div>
      <div className="text-sm font-medium text-promGray2">
        cost <BillingIntervalDisplay billingInterval={billingInterval} />
      </div>
      <div className="font-semibold text-4xl">{price}</div>
      <div className="mt-4 text-sm font-medium text-promGray2">
        Next Payment
      </div>
      <GetNextPaymentTextForCurrentPlan />
    </div>
  );
}

const mapStateToProps = (state: RootState, props: Props) => {
  return {
    ...props,
  };
};

export default connect(mapStateToProps)(CurrentPlanCard);
